import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@helm/design/tokens.css";
import "./shell.css";
import "./widgets.css";
import "./auth.css";
import "./glacis.css";
import "./tradovate.css";
import "./appearance.css";
import "@helm/design/moods.css";
// Every module stylesheet, in the cascade order they had before code splitting (audit S-12).
// Lazy chunks import their own CSS too, but the build ships one stylesheet (`cssCodeSplit:
// false`) and the first import fixes a sheet's position, so this list is the cascade order.
// Add new module stylesheets here as well.
import "dockview/dist/styles/dockview.css";
import "./chart/indicators/indicators.css";
import "./chart/chart.css";
import "./chart/lastDetails.css";
import "./chart/pine/pine.css";
import "./chart/drawings/drawings.css";
import "./trading/trading.css";
import "./trading/domControls.css";
import "./brackets/brackets.css";
import "./chart/chartTrading.css";
import "./chart/chartSettings.css";
import "./chart/tradovate/tradovate.css";
import "./chart/chartLayout.css";
import "./chart/compareTemplates.css";
import "./settings/data.css";
import "./settings/rithmic.css";
import "./topbar/rithmicAccount.css";
import "./copy/copy.css";
import "./sidebar/sidebar.css";
import "./tables/tables.css";
import "./topbar/tradovateTopBar.css";
import "./toolbar/toolbar.css";
import { App } from "./App";

const root = document.getElementById("root");
if (!root) throw new Error("#root missing");

// Dev-only preview of the signed-in shell with synthetic data (`/?preview`). The branch and the
// dynamic import are removed from production builds (import.meta.env.DEV is statically false).
if (import.meta.env.DEV && new URLSearchParams(location.search).has("preview")) {
  void import("./preview/Preview").then(({ Preview }) => {
    createRoot(root).render(
      <StrictMode>
        <Preview />
      </StrictMode>,
    );
  });
} else {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
